import { getSrcs } from '@helpers/image';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './RangeCard.styles';
const RangeCard = ({ cta, image, imgSizes, isNew, prefixes, styles, subtitle, title, titleSize = 'default', titleType = 'h3', showCta, showSubtitles = true, useSquareImages = false, showRangeCount = false, rangeCount = '', colours, isOffer, onSetCurrentSelection, suffixes, }) => {
    let aspectRatio = 454 / 836;
    if (useSquareImages) {
        aspectRatio = 1;
    }
    const srcs = getSrcs(image, 531, 233, 7, aspectRatio);
    const orientation = React.useMemo(() => (colours && !!colours.find((c) => !!c.isPortrait) ? 'portrait' : 'landscape'), [colours]);
    return (React.createElement(S.Container, { "data-title-size": titleSize },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Link, { ...(cta && !isOffer
                    ? {
                        as: 'a',
                        href: cta.url,
                        title: cta.text,
                        target: cta.target,
                    }
                    : isOffer === true
                        ? {
                            as: 'button',
                            onClick: () => {
                                onSetCurrentSelection &&
                                    colours &&
                                    onSetCurrentSelection(title, colours, cta?.url ?? '', suffixes?.count ?? 'finishes', orientation);
                            },
                        }
                        : {}), "data-is-link": !!cta, "data-is-offer": isOffer },
                React.createElement(S.ImageWrapper, { "data-square-image": useSquareImages },
                    React.createElement(S.Image, { sizes: imgSizes, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), role: !image.altText ? 'presentation' : undefined, loading: "lazy", alt: image.altText })),
                React.createElement(S.Title, { as: titleType },
                    isNew && React.createElement(S.New, null, prefixes.isNew),
                    " ",
                    title),
                showSubtitles && subtitle && React.createElement(S.SubTitle, null, subtitle),
                showRangeCount || rangeCount ? (React.createElement(S.RangeWrapper, null,
                    prefixes.count ?? 'Available in',
                    ' ',
                    React.createElement(S.RangeCount, null, styles && styles.length > 0 ? styles.length : rangeCount),
                    ' ',
                    suffixes?.count ?? 'finishes')) : (React.createElement(React.Fragment, null, styles && styles.length > 0 && (React.createElement(S.RangeWrapper, null,
                    React.createElement(S.Prefix, null, prefixes.styles),
                    React.createElement(S.Ranges, null, styles.map((style, i) => `${style}${i === styles.length - 1 ? '.' : i === styles.length - 2 ? ' & ' : ', '}`)))))),
                cta && showCta && (React.createElement(S.Cta, { href: cta.url, title: cta.text, target: cta.target },
                    cta.text,
                    " >"))))));
};
export default RangeCard;
